import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  description: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h4" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ color: '#666' }}>
        {description}
      </Typography>
    </Box>
  );
};

export default PageHeader;
